import React from "react";
import {Image} from "react-bootstrap";
import Facebook from "../../../assests/images/facebook.svg";
import Twitter from "../../../assests/images/blog-page-images/white-twitter-x.svg";
import DoubleQuotes from "../../../assests/images/invite-reviews-images/double-quotes.svg";
import {
    SocialMediaRequestsSection,
    SocialMediaRequestsWrap,
    SocialMediaRequestsTitle,
    SocialMediaUnorderedList,
    SocialMediaUListView,   
    SocialMediaIcon,
    SocialMediaText,
    SocialMediaStrong,
    IdeasCollectingReviewsWrap,
    IdeasCollectingReviewsContent,
    ReviewsClientName,
    ReviewsClientNameSpan,
    SocialMediaMain,
    ReviewDashSpan,
} from "./SocialMediaRequestsStyle"
import { useNavigate } from "react-router-dom";


const SocialMediaRequests = ({endorsementsData}:any) => {
    const navigate = useNavigate();
    return (
        <SocialMediaRequestsSection>    
            <SocialMediaRequestsWrap className="social-media-requests-box">
                <SocialMediaRequestsTitle className="social-media-requests-box-title">Social Media Requests for Volunteers, Clients Served & Board Members</SocialMediaRequestsTitle>
                
                <SocialMediaIcon className="doubleQuotes-icon-bg">
                    <Image src={DoubleQuotes} alt="facebook icon" />
                </SocialMediaIcon>
                
                <SocialMediaMain className="social-media-requests-box-wrap">
                    <SocialMediaUnorderedList className="social-media-req-ul">
                                            
                        <SocialMediaUListView className="social-media-req-li">
                        </SocialMediaUListView>
                    
                        <SocialMediaUListView className="social-media-req-li">
                            <SocialMediaIcon className="facebook-icon-bg">
                                <Image src={Facebook} alt="facebook icon" />
                            </SocialMediaIcon>
                            <SocialMediaText>Hey Volunteers! Share your volunteer experience. Write a review about us @GreatNonprofits. <SocialMediaStrong>[INSERT YOUR PROFILE PAGE URL]</SocialMediaStrong></SocialMediaText>
                        </SocialMediaUListView>
                    
                        <SocialMediaUListView className="social-media-req-li">
                            <SocialMediaIcon className="twitter-icon-bg">
                                <Image src={Twitter} alt="facebook icon" />
                            </SocialMediaIcon>
                            <SocialMediaText >Did you know you can help <SocialMediaStrong>[INSERT YOUR NONPROFIT NAME]</SocialMediaStrong> by simply writing a review? Review us @GreatNonprofits today. <SocialMediaStrong>[INSERT YOUR NONPROFIT PROFILE URL]</SocialMediaStrong></SocialMediaText>
                        </SocialMediaUListView>
                    
                    </SocialMediaUnorderedList>
                    
                    <IdeasCollectingReviewsWrap className="ideas-collecting-reviews">                                    
                        <IdeasCollectingReviewsContent className="reviews-content-text">{endorsementsData ? endorsementsData.quote : ""}</IdeasCollectingReviewsContent>
                
                        <ReviewsClientName><ReviewDashSpan className="dash-review"></ReviewDashSpan>{endorsementsData ? endorsementsData.quoteBy : ""} <ReviewsClientNameSpan onClick={() => navigate("/org/1")}>{endorsementsData ? endorsementsData.from : ""} </ReviewsClientNameSpan> </ReviewsClientName>
                        
                    </IdeasCollectingReviewsWrap>
                </SocialMediaMain>

            </SocialMediaRequestsWrap>
        </SocialMediaRequestsSection>
    )
};
export default SocialMediaRequests;